export default "__VITE_ASSET__DdsbpQPI__"